<template>

  <edit-pane  ref="ins" prefix="Insurance: ":title="ins.policyType"
    :editable="isManager('finance|property|admin') ? true : false"
    :is-edit="editMode"
    @save="onSave" @cancel="onCancel" @edit="onEdit" @add="onSave">

    <el-row>

      <el-form :inline="true" label-position="left" label-wdith="120px">

      <el-col :sm="24" :md="12" :lg="12">

        <el-row>
          <h4>Policy</h4>
        </el-row>

        <el-row>
          <el-col :span="24">
              <select-insurance-policy-type v-model="ins.policyType" :disabled="disabled" />
              <text-input label="Policy No." v-model="ins.policyNo" :disabled="disabled" />

              <el-row>
                <date-input label="Started" v-model="ins.coverageStart" :disabled="disabled"  />
                <date-input label="Expiry" v-model="ins.coverageEnd" :disabled="disabled" />
             </el-row>

              <float-input v-if="canAccess('finance|admin')" label="Premium" v-model="ins.premium"  :disabled="disabled" />
              <float-input  v-if="canAccess('finance|admin')" label="Insured Amount" v-model="ins.insuredAmount"  :disabled="disabled" />
          </el-col>
        </el-row>
      </el-col>


    <el-col :sm="23" :md="11" :lg="11" :offset="1">
      <el-col :span="24">
        <h4>Insurer</h4>
      </el-col>

      <el-col :span="6">
        Insurer
      </el-col>
      <el-col :span="16">
        <strong v-if="disabled">{{provider.name}}&nbsp;</strong>
        <select-insurer v-else label="" v-model="ins.organisation_id" :callback="orgChange" :disabled="disabled" />
      </el-col>

      <el-col :span="6">
        Address
      </el-col>
      <el-col :span="16">
        <strong>{{provider.address}}&nbsp;</strong>
      </el-col>

      <el-col :span="6">
        Post Code
      </el-col>
      <el-col :span="16">
        <strong>{{provider.postCode}}&nbsp;</strong>
      </el-col>

      <el-col :span="6">
        Phone
      </el-col>
      <el-col :span="16">
        <strong>{{provider.phone}}&nbsp;</strong>
      </el-col>

      <el-col :span="6">
        e-Mail
      </el-col>
      <el-col :span="16">
        <strong>
        <a v-if="ins.policyNo" :href="'mailto:' + provider.email
          + '?subject=RE: Policy No ' + ins.policyNo">{{provider.email}}</a>
        <a v-else :href="'mailto:' + provider.email">{{provider.email}}</a>
      </strong>
      </el-col>
    </el-col>

<!--
    @BUG for some reason, this hangs the whole screen with: nextTick has invalid character, or some such.
    <el-col ;span="24">
      <html-input label="Remarks" v-model="ins.remarks" :disabled="disabled" />
    </el-col>
-->
    </el-form>

    </el-row>

    <el-row v-if="canAccess('finance|admin') && ins.site_id && ins.id">
      <el-col :span="24">
          <files-panel title="Policy Document" type="site" :id="ins.site_id" process="insurance" :process-id="ins.id" />
      </el-col>
    </el-row>

<!--
    <div v-if="showRenewal && canAccess('finance')">
      <br />

      <el-row :gutter="11">
        <el-col :sm="23" :md="20" :lg="14">
          <insurance-renewal :rowData="rowData" />
        </el-col>

        <el-col :sm="1" :md="4" :lg="10">
          &nbsp;
        </el-col>
      </el-row>
    </div>

  </el-form>

-->

</edit-pane>

</template>


<script>

import SiteMixins from '@/mixins/SiteMixins'

import InsuranceAction from '@/components/actions/InsuranceAction'
import SelectInsurer from '@/components/atoms/selects/SelectInsurer'
import SelectInsurancePolicyType from '@/components/atoms/selects/SelectInsurancePolicyType'

import InsuranceRenewal from '@/components/sites/insurance/InsuranceRenewal'
import InsuranceStatement from '@/components/sites/insurance/InsuranceStatement'

export default {
  components: {
    InsuranceAction,
    InsuranceRenewal,
    InsuranceStatement,
    SelectInsurer,
    SelectInsurancePolicyType
  },

  mixins: [SiteMixins],

  props: {
    rowData: {
      type: Object,
      required: true
    },

    siteId: {
      type: Number,
      required: true
    },

    siteName: {
      type: String,
      rquired: true
    },

    editable: {
      type: Boolean,
      default: false
    },
    tableRef: {
      type: String,
      default: 'insurancetable'
    }
  },

  methods: {
    resetData () {
      this.ins = this.getTableStruct('insurance')
      this.ins.site_id = this.localSiteId
    },

    success (response) {
      this.$events.fire(this.tableRef + '-refresh-table')
      this.resetData()
    },

    onCancel () {
      this.disabled = true
    },

    onEdit () {
      this.disabled = false
    },

    onAdd () {
      this.disabled = false
      this.onSave()
    },

    onSave () {
      if (!this.ins.site_id && this.siteId) {
        this.ins.site_id = this.siteId
      }

      this.ins.coverageStart = this.formatDateSql(this.ins.coverageStart)
      this.ins.coverageEnd = this.formatDateSql(this.ins.coverageEnd)

      this.saveForm(this, '/insurance', this.ins.id, this.ins, this.ins.policyType + ' ' + this.ins.policyNo, this.success)
      this.disabled = true
      //      this.resetData()
    },

    onClose () {
      this.resetData()
    },

    orgChange (id, name, data) {
//      console.log('orgChange', id, name, data)
      if (data) {
        this.provider = data
      }
    }

  },

  data () {
    return {
      editMode: false,
      disabled: true,

      site: {
        siteId: this.siteId,
        siteName: this.siteName
      },

      ins: this.rowData,
      provider: this.rowData.provider
    }
  },

  created () {
//    console.log('Ins. Pol- rowData: ', this.rowData)
  }
}

</script>



// WEBPACK FOOTER //
// InsurancePolicy.vue?959042fa